/**
 * @generated SignedSource<<d0e859734ddab61a9b1acbca6e5a41e0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type InteriorsLandingPageModuleType = "banners" | "designers" | "head" | "projects" | "rooms" | "roomsPresentFlag" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type InteriorsLandingWrapper_viewer$data = {
  readonly interiorsLandingPage: {
    readonly moduleOrder: ReadonlyArray<InteriorsLandingPageModuleType | null> | null;
    readonly roomsHeadModule: {
      readonly " $fragmentSpreads": FragmentRefs<"InteriorsLandingRoomsHeader_roomsHeadModule">;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"InteriorsLandingDesigners_designersModule" | "InteriorsLandingProjects_projectsModule" | "InteriorsLandingRooms_roomsModule">;
  } | null;
  readonly " $fragmentType": "InteriorsLandingWrapper_viewer";
};
export type InteriorsLandingWrapper_viewer$key = {
  readonly " $data"?: InteriorsLandingWrapper_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"InteriorsLandingWrapper_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "getLive"
    },
    {
      "kind": "RootArgument",
      "name": "id"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "InteriorsLandingWrapper_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "getLive",
          "variableName": "getLive"
        },
        {
          "kind": "Variable",
          "name": "id",
          "variableName": "id"
        }
      ],
      "concreteType": "InteriorsLandingPage",
      "kind": "LinkedField",
      "name": "interiorsLandingPage",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "moduleOrder",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "InteriorsLandingModuleItem",
          "kind": "LinkedField",
          "name": "roomsHeadModule",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "InteriorsLandingRoomsHeader_roomsHeadModule"
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "InteriorsLandingRooms_roomsModule"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "InteriorsLandingDesigners_designersModule"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "InteriorsLandingProjects_projectsModule"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "7c77fa2b47ccf6f7a4b0da85700426fc";

export default node;
